/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import BASESvgIcon from "../../../../@BASE/core/BASESvgIcon";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import NavLinkAdapter from "../../../../@BASE/core/NavLinkAdapter";
import { useParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const StyledListItem = styled(ListItem)(({ theme, active }) => ({
  '&.active': {
    backgroundColor: theme.palette.background.royalBlue,
    color: theme.palette.primary.contrastText,
  },
}));

function SectionListPageItem(props) {
  const { page, commentCount } = props;
  const routeParams = useParams();
  return (
    <>
      <StyledListItem
        className="px-16 py-16"
        active={routeParams.id === page.id ? 1 : 0}
        id={routeParams.id === page.id ? "active-page" : ""}
        sx={{ bgcolor: "background.paper" }}
        button
        component={NavLinkAdapter}
        to={`/pages/${page.id}`}
        activeClassName="active"
        secondaryAction={
          commentCount !== 0 && (
            <Chip 
              icon={<BASESvgIcon>heroicons-outline:chat</BASESvgIcon>} 
              label={commentCount}
              color="secondary"
            />
          )
        }
      >
        <ListItemText
          classes={{ root: "m-0", primary: "font-medium leading-5 truncate" }}
          primary={page.title}
          secondary={
            <>
              <Typography
                className="inline"
                component="span"
                variant="body2"
                color={routeParams.id === page.id ? "#ffffff" : "text.secondary"}
              >
                {page.label}
              </Typography>
            </>
          }
        />
      </StyledListItem>
      <Divider />
    </>
  );
}

export default SectionListPageItem;
